import { createAction } from "redux-actions";

export const getConfigCiTestCases = createAction("GET_CONFIG_CI_TEST_CASES");
export const setConfigCiTestCases = createAction("SET_CONFIG_CI_TEST_CASES");
